function checkisSubscribedUser() {
    let subscribed = $.cookie('isSubscribedUser');

    if (subscribed == null || subscribed == 0) {
        $('#subscribe-wall').removeClass('d-none');
    } else {
        $('#subscribe-wall').addClass('d-none');
    };
    if (!$('#subscribe-wall').length || $('#subscribe-wall').hasClass('d-none')) {
        $('#articleAside').addClass('scroll');
    }
}

var aForm = document.querySelectorAll('[data-needs-validation]');

if (aForm.length) {
    aForm.forEach(af => {

        const hasSelect = (select) => {
            if (select.value === '') {
                select.classList.add('gray');
            } else {
                select.classList.remove('gray');
            }
        }

        const selects = af.querySelectorAll('select');

        selects.forEach(select => {
            select.addEventListener('change', () => {
                hasSelect(select);
            });
        });

        document.addEventListener('input', () => {
            saveFormLocal(af);
            renderLabelClass();
            checkSubmitReady(af);
        });
        document.addEventListener('click', () => {
            saveFormLocal(af);
            checkSubmitReady(af);
        });
        document.addEventListener('DOMContentLoaded', () => {
            drawSavedForm(af);
            checkAll();
            checkSubmitReady(af);
        });
    })
};

function checkSubmitReady(af) {
    const errorElements = af.querySelector('.form__error');
    let blankRequired = 0;
    const closedButton = af.closest('form').querySelector('button[type=submit]');

    af.querySelectorAll('[required]').forEach(requiredField => {
        if (requiredField.type == 'checkbox' && !requiredField.checked) {
            blankRequired++;
        } else if (requiredField.type == 'radio') {
            const name = requiredField.name;
            const oneChecked = af.querySelector(`input[type="radio"][name="${name}"]:checked`);

            if (!oneChecked) {
                blankRequired++;
            }
        } else if (!requiredField.value || requiredField.value == '') {
            blankRequired++;
        }
    })

    const submitTrigger = errorElements == null && blankRequired == 0;

    submitTrigger ? closedButton.removeAttribute('disabled') : closedButton.setAttribute('disabled', 'true');
}

function saveFormLocal(af) {
    var formContent = {},
        formElements = af.querySelectorAll('input,textarea,select');

    formContent = Object.keys(formElements).reduce((sum, current) => {
        var renderValue = '',
            elementLocalName = formElements[current].localName;

        if (elementLocalName == 'input') {
            switch (formElements[current].type) {
                case 'radio':
                    checkedSelector = document.querySelector(`input[name=${formElements[current].name}]:checked`);
                    if (checkedSelector) {
                        renderValue = checkedSelector.value;
                    }
                    renderLabelClass(formElements[current]);
                    break;
                case 'checkbox':
                    renderValue = formElements[current].checked;
                    renderLabelClass(formElements[current]);
                    break;
                case 'email':
                    renderValue = formElements[current].value;
                    let isBlocked = filterEmailDomains(formElements[current].value);
                    if (isBlocked) {
                        inputMessage(formElements[current], 'error', formElements[current].dataset.err);
                    };
                    if (!isBlocked) {
                        inputMessage(formElements[current], 'remove');
                    };
                    break
                default:
                    renderValue = formElements[current].value;
            }
        }
        if (elementLocalName == 'textarea' || elementLocalName == 'select') {
            renderValue = formElements[current].value
        }

        return { ...sum, [formElements[current].name]: [renderValue] };
    }, 0);

    localStorage.setItem($(af).attr('id'), JSON.stringify(formContent));

};

function checkAll() {
    var trigger = document.querySelectorAll('[data-checkall]');

    trigger.forEach(t => {
        t.onclick = () => {
            var checkBoxes = document.querySelectorAll(t.dataset.checkall),
                checkedCount = 0;

            checkBoxes.forEach(ch => {
                if (ch.checked == true) checkedCount += 1;
            })

            if (checkedCount < checkBoxes.length) {
                checkBoxes.forEach(ch => {
                    ch.checked = true;
                    renderLabelClass(ch);
                });
            } else {
                checkBoxes.forEach(ch => {
                    ch.checked = false;
                    renderLabelClass(ch);
                });
            }
        }
    })
}

function drawAlerts() {
    var alerts = document.querySelectorAll('[data-required]'),
        uncheckedCount = 0;

    alerts.forEach(al => {
        var targets = document.querySelectorAll(al.dataset.required),
            watcher = document.querySelector(al.dataset.watcher),
            trigger = 0;

        targets.forEach(t => {
            switch (t.type) {
                case "checkbox":
                    if (t.checked == true) trigger += 1;
                    break;
                case "text":
                    if (t.value != '') trigger += 1;
                    break;
            }
        })

        if (trigger > 0) {
            al.classList.add('d-none');
            watcher.checked = true;
            uncheckedCount += 0;
        } else {
            al.classList.remove('d-none');
            watcher.checked = false;
            al.scrollIntoView();
            uncheckedCount++;
        };
    })
    return uncheckedCount == 0 ? 'OK' : 'error';
}

function drawSavedForm(af) {
    var formElements = af.querySelectorAll('input,textarea,select'),
        storedData = JSON.parse(localStorage.getItem('requestForm'));

    if (storedData) {
        formElements.forEach(el => {
            var elementLocalName = el.localName;

            if (elementLocalName == 'input') {
                switch (el.type) {
                    case 'checkbox':
                        el.checked = storedData[el.name][0];
                        renderLabelClass(el);
                        break;
                    case 'radio':
                        if (el.value == storedData[el.name]) {
                            el.checked = true;
                        }
                        renderLabelClass(el);
                        break;
                    default:
                        el.value = storedData[el.name] == 'undefined' ? '' : storedData[el.name];
                };
            }
            if (elementLocalName == 'textarea' || elementLocalName == 'select') {
                el.value = storedData[el.name];
            }
        });

        var selectDropdown = document.querySelectorAll('.form-field__dropdown');
        selectDropdown.forEach(sel => {
            var realValue = sel.parentElement.querySelector('input[type=text]').value || 'other';
            sel.querySelector('img').setAttribute('src', `/images/flags/${realValue}.svg`);
            sel.querySelector('span').innerHTML = document.querySelector(`a[data-value=${realValue}`).innerText;
        })
    }
}

function renderLabelClass(el) {
    if (!el) return;
    el.parentElement.classList.toggle('form-field_selected', el.checked == true);
}

function filterEmailDomains(value) {
    const filterArray = [
        'gmail',
        'proton',
        'protonmail',
        'pm',
        'onmicrosoft',
        'yahoo',
        'myyahoo',
        'zoho',
        'aol',
        'gmx',
        'icloud',
        'me',
        'mac',
        'web',
        't-online',
        'freenet',
        '1and1',
        'libero',
        'virgilio',
        'tim',
        'mailchimp'
    ];
    const filterRegex = new RegExp('(@|\\.)(' + filterArray.join('|') + ')\\.', 'i');

    return filterRegex.test(value)
}

function inputMessage(el, type, message = null) {
    const parentGroup = el.closest('.form__group');
    const messageSmall = parentGroup.querySelector('small');

    switch (type) {
        case 'error':
            parentGroup.classList.add('form__error');
            if (messageSmall) messageSmall.remove();
            let err =
                parentGroup.insertAdjacentHTML("beforeend", `
            <small class="error">${message}</small>`
                );
            break;
        default:
            parentGroup.classList.remove('form__error');
            if (messageSmall) messageSmall.remove();
    }
}

function greCaptcha() {
    return new Promise(resolve => {
        grecaptcha.ready(function () {
            grecaptcha.execute('6LdV2Z4kAAAAAKntrwZ1ThPF_iaZXxGDeJm4uAzj', { action: 'submit' }).then(function (token) {
                resolve(token);
            });
        })
    })
}

function sendForm(form) {
    const formId = form.attr('id');
    let requestURI = '/';

    const listSubscribersFrom = ['subscribe-sb-article'];
    const submitBtn = form.find('[type=submit]');
    const dataForm = form.attr('data-form');
    const isNotFormsSubscribeForm = listSubscribersFrom.every(item => item !== dataForm);

    const svg = `<svg class="submit-loader" xmlns="http://www.w3.org/2000/svg" width="31" height="32" viewBox="0 0 31 32" fill="none">
        <g clip-path="url(#clip0_19021_4308)">
            <path d="M2.50169 16.2272C2.37639 9.04862 8.09422 3.12763 15.2728 3.00233C22.4514 2.87703 28.3724 8.59486 28.4977 15.7735C28.623 22.9521 22.9052 28.8731 15.7266 28.9984" stroke="white" stroke-width="4"/>
        </g>
        <defs>
            <clipPath id="clip0_19021_4308">
                <rect width="30" height="30" fill="white" transform="translate(30.7593 30.7363) rotate(179)"/>
            </clipPath>
        </defs>
    </svg>`;

    const btnContent = submitBtn.find('[data-text-btn]');

    btnContent.css('opacity', '0');
    $(submitBtn).addClass('disabled-color');
    $(submitBtn).append(svg);

    switch (formId) {
        case 'resourcesRequestForm':
            requestURI = '/resources/sendRequest.php';
            break;
        case 'customSolutionsForm':
            requestURI = '/custom-solutions/sendRequest.php';
            break;
        case 'kryptowaehrungenForm':
            requestURI = '/kryptowaehrungen/sendRequest.php';
            break;
        case 'askJanFormArticle':
            requestURI = '/components/ask-jan-form/sendRequest.php';
            break;
        case 'da20Form':
            requestURI = '/crypto-basket-etp-da20/sendRequest.php';
            break;
        case 'da20FormSwiss':
            requestURI = '/crypto-basket-etp-da20-ch/sendRequest.php';
            break;
        case 'event-form':
            requestURI = '/components/event-form/sendRequest.php';
            break;
        default:
            requestURI = form.attr('action');
            break;
    };

    $.getScript("https://www.google.com/recaptcha/api.js?render=6LdV2Z4kAAAAAKntrwZ1ThPF_iaZXxGDeJm4uAzj", async function () {
        let gre_token = await greCaptcha().finally(() => {
            $(submitBtn).find('svg').remove();
            btnContent.css('opacity', '1');
            $(submitBtn).removeClass('disabled-color');
        });

        let requestQuery = form.serialize() + `&gretoken=${gre_token}`;

        $.post(requestURI, requestQuery, function (data) {

            const response = data;

            switch (data) {
                case 'OK':
                    data = 'success';
                    break;
                case 'error: Unable to create contact, email is already associated with another Contact':
                    data = 'Contact already exist';
                    break;
                default:
                    data = 'Error: Please reload the page ';
            }

            if (data == 'success') {
                gtag('event', 'submit', {
                    'event_category': 'submit',
                    'event_page': window.location.pathname,
                    'event_area': formId,
                    'event_label': `Submit the ${formId}`
                });

                if (dataForm == 'subscribe-sb-report') {
                    statusFormModal(data, dataForm, 'report');
                } else if (dataForm == 'register-event') {
                    statusFormModal(data, dataForm, 'event');
                } else {
                    statusFormModal(data, dataForm);
                }

                $.cookie("isSubscribedUser", "1", {
                    path: '/', secure: true
                });

                checkisSubscribedUser();
            }
            else {
                if (data == 'Contact already exist') {

                    if (dataForm == 'subscribe-sb-report') {
                        statusFormModal(data, dataForm, 'report');
                    } else {
                        statusFormModal(data, dataForm);
                    }

                    $.cookie("isSubscribedUser", "1", {
                        path: '/', secure: true
                    });

                    checkisSubscribedUser();
                } else {

                    statusFormModal(data, dataForm);

                    $.cookie("isSubscribedUser", "0", {
                        path: '/', secure: true
                    });
                    checkisSubscribedUser();
                }
                return false;
            }

            function statusFormModal(data, dataForm, typeModal = "status") {
                if ($(document.body).is('.modal-open')) {
                    $('.modal.show').modal('hide');
                }

                if (data == 'success') {
                    $('.modal-status-success').removeClass('d-none');
                    $('.modal-status-error').addClass('d-none');

                    switch (dataForm) {
                        case 'subscribe-sb':
                            $('[data-response=default]').addClass('d-none');
                            $('[data-response=subscribe]').removeClass('d-none');
                            break;
                        default:
                            $('[data-response=default]').removeClass('d-none');
                            $('[data-response=subscribe]').addClass('d-none');
                            break;
                    }
                } else {
                    $('.modal-status-error').removeClass('d-none');
                    $('.modal-status-success').addClass('d-none');

                    if (data === 'Contact already exist') {
                        switch (dataForm) {
                            case 'subscribe-sb':
                                $('[data-response=auto-err]').addClass('d-none');
                                $('[data-response=subscribe-err]').removeClass('d-none');
                                break;
                            case 'subscribe-sb-report':
                                $('.modal-status-error').addClass('d-none');
                                $('.modal-status-success').removeClass('d-none');
                                $('[data-response=already-hide]').addClass('d-none');
                                $('[data-response=already-show]').removeClass('d-none');

                                break;
                            default:
                                $('[data-response=auto-err]').addClass('d-none');
                                $('[data-response=subscribe-err]').removeClass('d-none');

                                return false;

                                break;
                        }
                    }

                    $('[data-response=auto-err]').removeClass('d-none');
                    $('[data-response=subscribe-err]').addClass('d-none');
                    $('.modal-error-message').text(data);
                    console.error(`Error: ${response}`);
                }

                $('[data-modal-type="' + typeModal + '"]').on('hidden.bs.modal', function () {
                    $('.modal-status-error').addClass('d-none');
                    $('.modal-status-success').removeClass('d-none');
                })

                $('[data-modal-type="' + typeModal + '"]').modal('show');
            }
        });
    })
}

$("form").submit(function (e) {
    e.preventDefault();
    let checkAlerts = drawAlerts();

    if (checkAlerts == 'OK') sendForm($(this));
})